/**
 * Created by RamKumar on 11/18/16.
 */

;(function (EG){
	'use strict';
	
	var defaultOptions = {
		key: 'key',
		shouldPersist: false,
		fetchData: function() {
			return {
				then: function(cb) {
					cb('');
				}
			};
		}
	};
	
	/**
	 * @constructor
	 * @param options
	 *
	 * Initializes with key that will act as unique ID to store values.
	 *
	 */
	function LocalCache(options){
		
		this.options = _.extend({}, defaultOptions, options);
		this.cache = {};
		this.cache[this.options.key] = {};
		
	}
	
	/**
	 * @public
	 * @param data {*}
	 *
	 * Stores the data into cache
	 */
	LocalCache.prototype.store = function (ids, data) {
		
		var key,
			id;
		
		key = this._getKey();
		id = this._getId(ids);
		
		this._storeData(key, id, data);
		
	};
	
	/**
	 * private
	 * @returns {String} KeyName
	 */
	LocalCache.prototype._getKey = function() {
		return this.options.key;
	};
	
	/**
	 * @public
	 * @returns {*} stored cache
	 */
	LocalCache.prototype.get = function (ids) {
		
		var data,
			key,
			id;

		key = this._getKey();
		id = this._getId(ids);
		data = this.cache[key][id];
		
		if (data) {
			return data;
		}
		
	};
	
	/**
	 * @private
	 * @param key {String}
	 * @param data {*}
	 */
	LocalCache.prototype._storeData = function ( key, id, data ) {
		this.cache[key][id] = data;
	};

    /**
	 *
     * @param ids
     * @returns {String}
     * @private
     */
    LocalCache.prototype._getId = function (ids) {
        if (_.isArray(ids)) {
            return ids.join('_');
        }
        return ids;
    };

	EG.Users.Libs.LocalCache = LocalCache;
	
})(EG);